module.exports = __webpack_public_path__ + "d86c4658896b188d608fb1bedfd28d09.png";